import React from "react";
import Footer from "../components/Footer";
import "../css/style.css";
import ContactIntro from "../components/ContactIntro";
import ContactFrom from "../components/Contact";
function Contact() {
  return (
    <div>
        
    <ContactIntro />
    <ContactFrom />
    <Footer />
    </div>
    
    
  );
}

export default Contact;
